<template>
    <v-container fluid tag="section" class="px-3">
        <for-sims-modal
                :object_id.sync="object_id"
                @closeModal="closeModal"
        />
        <v-row>
            <v-col>
                <base-material-card
                        inline
                        icon="mdi-clipboard-text"
                        title="Таблица сценариев для сим-карт"
                        class="px-5 py-3 mb-0 col-sm-12"
                >
                    <v-card class="my-0">
                        <v-card-title class="pl-0 mb-2">
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    :label="$t('search')"
                                    color="secondary"
                                    single-line
                                    hide-details
                                    class="search-width"
                            ></v-text-field>
                        </v-card-title>
                    </v-card>
                    <v-data-table
                            :headers="headers"
                            :items="mainArray"
                            class="caption"
                            :mobile-breakpoint="900"
                            :page.sync="page"
                            @page-count="pageCount = $event"
                            :fixed-header="true"
                            :height="tableHeight"
                            hide-default-footer
                            :items-per-page="itemsPerPage"
                            hoverable="false"
                    >
                        <template v-slot:item.id="{ item }">
                            <span class="text-overflow caption">{{ item.id }}</span>
                        </template>

                        <!-- phone_first -->
                        <template v-slot:item.phone_first="{ item }">
                            <span class="text-overflow caption">{{ item.phone_first }}</span>
                        </template>

                        <!-- wait_first -->
                        <!--<template v-slot:item.wait_first="{ item }">
                            <span class="text-overflow caption">{{ item.wait_first }}</span>
                        </template>-->

                        <!-- phone_second -->
                        <template v-slot:item.phone_second="{ item }">
                            <span class="text-overflow caption">{{ item.phone_second }}</span>
                        </template>

                        <!-- wait_second -->
                        <!--<template v-slot:item.wait_second="{ item }">
                            <span class="text-overflow caption">{{ item.wait_second }}</span>
                        </template>-->

                        <!-- phone_third -->
                        <template v-slot:item.phone_third="{ item }">
                            <span class="text-overflow caption">{{ item.phone_third }}</span>
                        </template>

                        <!-- wait_third -->
                        <!--<template v-slot:item.wait_third="{ item }">
                            <span class="text-overflow caption">{{ item.wait_third }}</span>
                        </template>-->

                        <!-- phone_fourth -->
                        <template v-slot:item.phone_fourth="{ item }">
                            <span class="text-overflow caption">{{ item.phone_fourth }}</span>
                        </template>

                        <!-- wait_fourth -->
                        <!--<template v-slot:item.wait_fourth="{ item }">
                            <span class="text-overflow caption">{{ item.wait_fourth }}</span>
                        </template>-->

                        <template v-slot:item.action="{ item }">
                            <div class="text-overflow caption">
                                <v-btn
                                        @click="edit(item.id)"
                                        icon
                                        small
                                        class="action-button green--text"
                                >
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <v-data-footer :show-current-page="true"></v-data-footer>
                    </v-data-table>

                    <div class="text-center mt-3 pagination-block">
                        <v-pagination
                                v-model="page"
                                :length="pageCount"
                                :total-visible="totalVisiblePagination"
                                color="#0051ff"
                        ></v-pagination>
                        <span class="row-options">
                            <label class="mr-2">Показывать строк</label>
                            <v-select
                                    :items="rowsOptions"
                                    v-model="rows"
                                    label
                                    dense
                                    solo
                                    @change="setRows"
                                    class="rows-options-select"
                                    item-color
                            ></v-select>
                        </span>
                    </div>
                </base-material-card>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
    import ForSimsModal from './components/ForSimsModal'

    import axios from 'axios'

    export default {
        name: 'ExtensSim',

        components: { ForSimsModal },

        data: function () {
            return {
                open: ['public'],
                tree: [],
                search: '',
                tableHeight: 'auto',
                page: 1,
                pageCount: 0,
                itemsPerPage: 10,
                totalVisiblePagination: 7,
                rowsOptions: [3, 5],
                rows: 5,
                isActive: false,

                headers: [
                    {
                        text: 'ID',
                        value: 'id',
                        align: 'center',
                        class: 'text-overflow font-weight-bold caption',
                    }, {
                        text: 'Номер/имя исходящей sim-карты',
                        value: 'phone_first',
                        align: 'center',
                        class: 'text-overflow font-weight-bold caption',
                    }, /*{
                        text: 'Время ожидание первого номера',
                        value: 'wait_first',
                        align: 'center',
                        class: 'text-overflow font-weight-bold caption',
                    },*/ {
                        text: '1-й номер/шаблон принимающего номера',
                        value: 'phone_second',
                        align: 'center',
                        class: 'text-overflow font-weight-bold caption',
                    }, /*{
                        text: 'Время ожидание второго номера',
                        value: 'wait_second',
                        align: 'center',
                        class: 'text-overflow font-weight-bold caption',
                    },*/ {
                        text: '2-й номер/шаблон принимающего номера',
                        value: 'phone_third',
                        align: 'center',
                        class: 'text-overflow font-weight-bold caption',
                    }, /*{
                        text: 'Время ожидание третьего номера',
                        value: 'wait_third',
                        align: 'center',
                        class: 'text-overflow font-weight-bold caption',
                    },*/ {
                        text: '3-й номер/шаблон принимающего номера',
                        value: 'phone_fourth',
                        align: 'center',
                        class: 'text-overflow font-weight-bold caption',
                    }, /*{
                        text: 'Время ожидание четвертого номера',
                        value: 'wait_fourth',
                        align: 'center',
                        class: 'text-overflow font-weight-bold caption',
                    },*/ {
                        text: 'Действие',
                        value: 'action',
                        align: 'center',
                        sortable: false,
                        class: 'text-overflow font-weight-bold caption',
                    },
                ],

                mainArray: [],

                // id - выбраного объекта:
                object_id: -1,
            }
        },

        methods: {
            setRows () {
                this.itemsPerPage = this.rows
            },

            /**
             * Получить список сценариев.
             */
            getExtensions() {
                axios({
                    method: 'get',
                    url: process.env.VUE_APP_API_URL_PHONE + 'get-list-extension-sim',
                }).then((response) => {

                    console.log(response.data);

                    this.mainArray = response.data;

                }).catch(error => alert(error));
            },

            edit( id ) {
                console.log('edit(): ' + id);

                this.object_id = id;
            },

            closeModal(){
                console.log('closeModal()');

                this.object_id = -1;

                this.getExtensions();
            }
        },

        created () {

            console.log('created() -- ExtensSim')

            this.getExtensions()
        },
    }
</script>


<style lang="scss" scoped>
    // сетка

    .row {
        height: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .column {
        height: 100%;
    }

    .left-column {
        flex: 0 0 290px;
    }

    .right-column {
        min-width: 370px;
    }

    .v-card {
        border-radius: 4px !important;
    }

    // левая колонка

    .v-card.tree {
        height: calc(100% - 30px);
    }

    .card-tree {
        position: relative;
        height: 100%;
    }

    .card-tree-title {
        position: absolute;
        top: -17px;
        width: calc(100% - 32px);
        min-height: 48px;
        font-size: 14px !important;
    }

    .card-tree-content {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    // правая колонка

    .v-card--material {
        height: calc(100% - 30px);
    }

    .v-data-table {
        height: calc(100% - 160px);
        overflow: auto;
    }

    // медиазапросы

    @media (max-width: 980px) {
        .row-options label {
            display: none !important;
        }
    }

    @media (max-width: 743px) {
        .v-card.tree {
            height: auto;
        }

        .row {
            height: auto;
        }

        .right-column {
            padding-left: 12px !important;
        }
    }

    // пагинация в таблице

    .pagination-block {
        display: flex;

        .row-options {
            display: flex;
            position: absolute;
            right: 20px;
            align-items: baseline;

            .v-select {
                width: 50px;
            }
        }
    }
</style>
